import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { History } from 'history';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import { Row } from 'components/UI/Row';
import { Search } from 'components/Search/Search';
import { productsPrefix } from 'routes/routes';
import { fetchProducts, resetSearchList, getLoaders } from './products';

const ProductListActions = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isLoading } = useSelector(getLoaders);
  const history: History = useHistory();
  const [groupComponents, setGroupComponents] = useState<boolean>(false);

  const searchProducts = (term: string) => dispatch(fetchProducts({ index: 1, search: term }));
  const resetSearchProducts = () => {
    dispatch(resetSearchList());
  };

  return (
    <div>
      <Row justifyContent="space-between" alignItems="center">
        <Search searchFunction={searchProducts} resetFunction={resetSearchProducts} searchLabel="product" />
        <div style={{ display: 'flex', flex: 0.5 }} />
        {/* use fab on mobile */}
        <Button
          variant="contained"
          disabled={isLoading}
          color="primary"
          onClick={() => history.push(`${productsPrefix}/new`)}
        >
          {t('products.add new')}
        </Button>
      </Row>
      <FormControlLabel
        style={{ marginLeft: '-4px' }}
        control={
          <Switch
            disabled={isLoading}
            checked={groupComponents}
            color="primary"
            onChange={e => {
              const { checked } = e.target;
              setGroupComponents(checked);
              dispatch(fetchProducts({ groupcomponents: checked }));
            }}
            value={groupComponents}
          />
        }
        label={t('products.list only parent products')}
      />
    </div>
  );
};

export { ProductListActions };
